import React, { createContext, useContext } from 'react'
import { Org } from '@integration-app/sdk'

import useAuth from '../../contexts/auth'
import useApi from '../../hooks/useApi'

interface IOrgContext {
  org: Org
  patchOrg(data: Partial<Org>): Promise<void>
}

const OrgContext = createContext<IOrgContext>({
  org: {},
  patchOrg: async () => {},
} as any)

export const OrgProvider = ({ orgId, children }) => {
  const { self, refresh } = useAuth()
  const { apiClient } = useApi()
  const org: Org | undefined = self?.orgs.find((o) => o.id === orgId)

  async function patchOrg(data: Partial<Org>) {
    if (!org) return

    await apiClient.patch(`/orgs/${org.id}`, data)
    await refresh()
  }

  const context = {
    org,
    patchOrg,
  }

  return (
    // @ts-ignore
    <OrgContext.Provider value={context}>{children}</OrgContext.Provider>
  )
}

export default function useOrg() {
  return useContext(OrgContext)
}
